'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a header for sections within sections.
 */
var SubSectionHeaderComponent = function SubSectionHeaderComponent(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    _reactBootstrap.Col,
    { xs: 12, className: 'section-subtitle' },
    _react2.default.createElement(
      'h4',
      { className: '' },
      (0, _translate.t)(children)
    )
  );
};

SubSectionHeaderComponent.propTypes = {
  children: _react2.default.PropTypes.any.isRequired
};

exports.default = SubSectionHeaderComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/SubSectionHeaderComponent.jsx
// module id = 208
// module chunks = 0